import { getConfig } from '@/config/config';
import { Vacation } from '@/features/vacation/vacationModel';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from './prepareHeader';
import { signalrConnection, startConnection } from '@/core/signalR/signalr.service';
import { handleVacationEvent, VacationNotificationPayload } from '@/api/vacation.service';

// Define a service using a base URL and expected endpoints
export const vacationApi = createApi({
  reducerPath: 'vacationApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${getConfig().apiUrl}/api/vacations`, prepareHeaders }),
  endpoints: (builder) => ({
    getVacations: builder.query<Vacation[], void>({
      query: () => `/`,
      async onCacheEntryAdded(
        arg,
        { dispatch, updateCachedData, cacheDataLoaded, cacheEntryRemoved },
      ) {
        //start signalR connexion
        await startConnection(dispatch);

        try {
          // wait for the initial query to resolve before proceeding
          await cacheDataLoaded;

          signalrConnection.on('ReceiveNotification', (payload: VacationNotificationPayload) => {
            handleVacationEvent(updateCachedData, payload, dispatch);
          });
        } catch {
          // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
          // in which case `cacheDataLoaded` will throw
        }
        // cacheEntryRemoved will resolve when the cache subscription is no longer active
        await cacheEntryRemoved;
        // perform cleanup steps once the `cacheEntryRemoved` promise resolves
        await signalrConnection.stop();
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetVacationsQuery } = vacationApi;
